module.exports = __webpack_public_path__ + "img/EG.399ae0ab.svg";